import { AppTexts, StyleKeys, StyleValues } from './../../objects/app-static-texts';
import { ChangeDetectionStrategy, Component, HostListener, OnInit } from '@angular/core';
import { AppManagementService } from '../../services/app-management.service';
import { CustomService } from '../../services/custom.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WelcomeComponent implements OnInit {
  pageDesignFlag: boolean =false;
  // PAGE OBJECT
  pageDesign: any;

  // IMAGE UPLOAD VARIABLE
  fileData: File = null;
  
  // FLAG FOR ENABLING SPIT SCREENS
  pageDivision: boolean = false;
  
  // STYLES APPLICAPLE WHEN PAGE DIVISION ENABLED
  pageDivStyle: any;
  pageLeftScreenStyle: any;
  pageRightScreenStyle: any;

  // FLAG FOR VIEW SWITCH BETWEEN CUSTOM AND TEMPLATE DESIGN
  customDesign:boolean = false;

  scroll:boolean=false;

  // VARIABLE FOR STORING CUSTOM CODE STRING
  htmlText: any;
  scroll_listener;

  constructor( 
    public appDesignService: AppManagementService, 
    public customService:CustomService,
    private router: Router) { }

  ngOnInit() {
      this.pageDesign = this.appDesignService.getPageDesign();
      if(this.pageDesign!=undefined){
        this.pageDesignFlag = true;
        if(this.appDesignService.clientSessionId!=undefined){
          //SENDING PAGE VIEW FOR GA
          this.customService.sendPageViewUpdate(this.pageDesign.name);
        }
      
        // APPLYING PAGE CONTAINER STYLE
        this.pageDesign[AppTexts.elementStyle] = this.appDesignService.applyElementStyle(this.pageDesign);

        // ADD TO SCREEN VIEW STACK
        this.appDesignService.addToScreenHistory(this.pageDesign.name, AppTexts.page);

        //IF PAGE DESIGN HAVE CUSTOM CODE
        if(this.pageDesign.custom_code !=undefined){
          
          //DECODE BASE64 CUSTOM CODE TO STRING
          this.htmlText = atob(this.pageDesign.custom_code);
          this.customDesign = true;

          var start=0;
          var end=0;
          
          for(let i = 0; i < this.htmlText.length; i++){
            if(this.htmlText[i]+""+this.htmlText[i+1] == "{{") { start = i+2; };
            if(this.htmlText[i]+""+this.htmlText[i+1] == "}}") { end = i; };
            
            if(start-end<0){
              var c = this.htmlText.substring(start,end);
              var value = '';  
            
              for(var e=0;e<this.pageDesign.element_flow.length;e++){
            
                if(this.pageDesign.element_flow[e].element_keyname == c){
            
                  switch(this.pageDesign.element_flow[e].element_keyname) {
                    case AppTexts.ScreenImage_1:
                      value = this.pageDesign.element_flow[e].src;
                      break;
              
                    default:
                      value = this.pageDesign.element_flow[e].text;
              
                  }
                }

              }

              this.htmlText = this.htmlText.replace("{{"+c+"}}",value);
              start = end = 0;
            
            }
          }
        }

        // IF PAGE DIVISION KEY IS AVAILABLE
        if(this.pageDesign.screen_division!=undefined) { this.pageDivision = this.pageDesign.screen_division; }

        // IF PAGE DIVISION IS ENABLED
        if(this.pageDivision){
          
          for (var t = 0; t < this.pageDesign.left_screen_element_flow.length; t++) {
            this.pageDesign.left_screen_element_flow[t][AppTexts.elementStyle] = this.appDesignService.applyElementStyle(this.pageDesign.left_screen_element_flow[t]);
          }
          
          this.pageLeftScreenStyle = this.appDesignService.applyStyles([AppTexts.leftWelcomeScreenDiv]);
          this.pageRightScreenStyle = this.appDesignService.applyStyles([AppTexts.rightWelcomeScreenDiv]);
          
          for (var t = 0; t < this.pageDesign.right_screen_element_flow.length; t++) {
            this.pageDesign.right_screen_element_flow[t][AppTexts.elementStyle] = this.appDesignService.applyElementStyle(this.pageDesign.right_screen_element_flow[t]);
          }

          this.pageDivStyle = { display: StyleValues.flex };
          
          // FOR MOBILE DESIGN
          if(this.appDesignService.isMobile){
            this.pageDivStyle[StyleKeys.flexDirection] = StyleValues.column;
            this.pageLeftScreenStyle[StyleKeys.width] = StyleValues.hundred_percentage;
            this.pageRightScreenStyle[StyleKeys.width] = StyleValues.hundred_percentage;
            this.pageRightScreenStyle[StyleKeys.padding] = "10% 0";
          }
          else{
            this.pageDivStyle[StyleKeys.flexDirection] = StyleValues.row;        
          }
          
        }
        
        //NORMAL ELEMENT FLOWS STACK LIST
        if(this.pageDesign.element_flow!=undefined){
          // ADDING STYLE TO EACH ELEMENT IN THE PAGE
          for (var t = 0; t < this.pageDesign.element_flow.length; t++) {
            // CUSTOM ELEMENT
            if(this.pageDesign.element_flow[t].type == AppTexts.customElement){
              this.pageDesign.element_flow[t].custom_html = atob(this.pageDesign.element_flow[t].custom_code);
            }
            else{
              this.updateIframeHeight();
              this.pageDesign.element_flow[t][AppTexts.elementStyle] = this.appDesignService.applyElementStyle(this.pageDesign.element_flow[t]);
            }         
          }
        }
        
        this.appDesignService.scrollToTop();
        setTimeout(() => { this.updateIframeHeight(); }, 300);
        this.captureImageLoadEvent();
      }
      else{
        this.appDesignService.redirectAppToBase();
      }
  }

  captureImageLoadEvent(){
    var imgs = document.querySelectorAll('img')
    for(var im=0;im<imgs.length;im++){
      if (imgs[im].complete) {
        this.updateIframeHeight()
      } else {
        imgs[im].addEventListener('load', this.updateIframeHeight)
        imgs[im].addEventListener('error', function() { })
      }
    } 
  }

  @HostListener('click', ['$event'])
  onClick(event: any) {    
    if(this.pageDesign!=undefined){
      for(var e=0;e<this.pageDesign.element_flow.length;e++){
        if(this.pageDesign.element_flow[e].element_keyname == event.target.id){
          this.customService.triggerFunction(this.pageDesign.element_flow[e])
        }
      }
    }
  }
  
  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.customService.baseConversion(this.fileData);
  }

  ngAfterViewChecked(){ this.updateIframeHeight(); }

  ngDoCheck() { this.updateIframeHeight(); }

  ngAfterContentChecked() { this.updateIframeHeight(); }

  updateIframeHeight(){
    if(this.pageDesign!=undefined){
      var ele = document.getElementById(this.pageDesign.name);
      if(ele!=null && ele!=undefined){
        this.appDesignService.sentHeight(ele.offsetHeight);
      }
    }
  }
}

